import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetSelfSentimentReportTimeSeriesRequestDto } from '../../../../interface/dtos/sentiment/get-self-sentiment-report-time-series.request.dto';
import { SelfSentimentReportTimeSeriesEntity } from '../../../domain/entities/sentiment/self-sentiment-report-time-series.entity';
import { GetSelfSentimentReportTimeSeriesDomainService } from '../../../domain/services/sentiment/get-self-sentiment-report-time-series.domain-service';
import { SentimentReportPort } from '../../ports/sentiment/sentiment-report.port';

export class GetSelfSentimentReportTimeSeriesApplicationService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly port: SentimentReportPort,
    protected readonly domainService: GetSelfSentimentReportTimeSeriesDomainService
  ) {}

  async execute(
    props: GetSelfSentimentReportTimeSeriesRequestDto
  ): Promise<SelfSentimentReportTimeSeriesEntity[]> {
    try {
      const result =
        await this.port.getSelfSentimentReportTimeSeriesForDateRange({
          startDate: props.params.startDate,
          endDate: props.params.endDate,
          token: props.config.token,
        });
      return await this.domainService.execute({
        startDate: props.params.startDate,
        endDate: props.params.endDate,
        data: result,
      });
    } catch (error) {
      throw new Error(
        `GetSelfSentimentReportTimeSeriesService.execute encountered an error ${error}`
      );
    }
  }
}
